(function(){
  var blocks = document.querySelectorAll('.dm-tabs-underline');
  if(!blocks.length) return;

  blocks.forEach(function(root, idx){
    // Aseguramos un "name" único de radios por bloque
    var radios = root.querySelectorAll('input[type="radio"]');
    var groupName = 'dm-tabs-' + (Date.now()) + '-' + idx;
    radios.forEach(function(r){ r.setAttribute('name', groupName); });

    var content = root.querySelector('.tab-content');
    var panels  = root.querySelectorAll('.tab-panel');
    var labels  = root.querySelectorAll('.tab-labels label');

    function lockHeight(){
      var max = 0;
      panels.forEach(function(p){
        var hidden = getComputedStyle(p).display === 'none';
        if(hidden){ p.style.display = 'block'; }
        max = Math.max(max, p.scrollHeight);
        if(hidden){ p.style.display = ''; }
      });
      if(max && content){ content.style.minHeight = max + 'px'; }
    }

    // Evita saltos al cambiar de tab
    labels.forEach(function(lab){
      lab.addEventListener('click', function(){
        var y = window.scrollY;
        requestAnimationFrame(function(){ window.scrollTo(0, y); });
        setTimeout(function(){ window.scrollTo(0, y); }, 0);
      });
    });

    lockHeight();
    window.addEventListener('load', lockHeight);
    window.addEventListener('resize', lockHeight);

    // Recalcular si se agregan nodos (imágenes, etc.)
    var mo = new MutationObserver(lockHeight);
    panels.forEach(function(p){ mo.observe(p, {childList:true, subtree:true}); });
  });
})();
